<template>
<div>
    <bar-manut 
        single-entity="Unidade de Medida" 
        plural-entity="Unidades de Medida" 
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <validation v-if="errmessages.length" title="Erros de validação" :messages="errmessages"></validation>
    <div class="default-container">
        <div>
            <div class="row">
                <form-field ref="uni" v-model="unimed.uni" :metadata="metadata.unimed.uni" type="text" col="3" 
                    :disabled="editing" name="uni" :v-errors="errors" v-validate="metadata.unimed.uni.validator"></form-field>
                <div class="w-100"></div>
                <form-field v-model="unimed.descricao" type="text" col="6" :metadata="metadata.unimed.descricao" 
                    name="descricao" :v-errors="errors" v-validate="metadata.unimed.descricao.validator"></form-field>
                <div class="w-100"></div>
                <!-- <form-field v-model="unimed.fracao" type="select" col="3" :metadata="metadata.unimed.fracao"></form-field> -->
                <!-- <form-field v-model="unimed.codibge" type="number" col="2" :metadata="metadata.unimed.codibge"
                    name="codibge" :v-errors="errors" v-validate="metadata.unimed.codibge.validator"></form-field> -->
            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
        importXml: {},
    },

    data() {
        return {
            crudText: '',
            unimed: {...this.$store.getters.getEntities.unimed},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: {},  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }
    },

    methods: {
        closeForm () {
            this.$emit('closeform')
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadUnimed', { id: this.index } )
            if (this.$store.getters.getUnimed) {
                this.unimed = {...this.$store.getters.getUnimed}
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/unimed/' + this.unimed.uni

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/unimed/'
            var sendData = {}

            sendData = { unimed: this.unimed }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.$emit('closeform', data.items[0])
            }

        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
            this.unimed.fracao = 'S'
        } else {
            this.loadData()  
        }

        if (this.importXml) {
            this.unimed.uni = this.importXml.uni
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.uni.focus()
        })

    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/unimed-form.vue